const categories = {
    Weapon: ['Axe', 'Mace', 'Sword', 'Staff', 'Dagger', 'Chain'],
    Shield: [],
    Armor: ['Head', 'Shoulder', 'Torso', 'Hand', 'Leg', 'Feet'],
    Accessory: ['Amulet', 'Armring', 'Cloak', 'Neck', 'Ring'],
    Potion: [],
    Material: [],
    Knowledge: ['Tome', 'Scroll', 'Book'],
    Rune: ['green', 'orange', 'blue', 'red', 'aqua', 'yellow', 'gray', 'purple']
} as const;

export default categories;
